var React = require('react');

function Note (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M17.1429 24L24 17.1566H17.1429V24ZM21.4286 0H2.57143C1.15125 0 0 1.14894 0 2.56627V21.3856C0 22.8505 1.15125 24 2.57143 24H15.4286L15.4288 17.1566C15.4288 16.2119 16.1965 15.4458 17.1431 15.4458H24V2.61439C24 1.19706 22.8482 0 21.4286 0Z"}));
}

Note.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Note;

Note.default = Note;
